// extracted by mini-css-extract-plugin
export default {"desktop-wrapper":"v7v2nI","desktopWrapper":"v7v2nI","mobile-wrapper":"YqmrMc","mobileWrapper":"YqmrMc"};